import { createErrorMessage } from "../service";
import api from "../api";
let apiDashboard = { ...api };
let helper = apiDashboard.apiUrl.split("/");
helper.pop();
apiDashboard.apiUrl = helper.join("/");
const Dashboard = {
  get(onSuccess = () => {}, onError = () => {}) {
    return apiDashboard
      .get("/internal/me/storage/webapp/dashboard")
      .then(res => {
        onSuccess(res.data.layout || []);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  update(dashboard, onSuccess = () => {}, onError = () => {}) {
    dashboard;
    return apiDashboard
      .put("/internal/me/storage/webapp/dashboard", { layout: dashboard })
      .then(res => {
        onSuccess(res.data.layout || []);
      })
      .catch(res => {
        onError(res);
      });
  }
};
export default Dashboard;
